import React from "react";
import { useWatch, Controller } from "react-hook-form";
import { defineMessages, useIntl } from "react-intl";
import { Box, Typography, Chip } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { MemoizedDefaultChip } from "../../../components/chip/ChipRenderer.js";
import { ChipType, ChipVariant } from "../../../components/chip/types.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "../../../components/editable/EditProvider.js";
import { withEditButton } from "../../../components/editable/EditButtonHoc.js";
import "../../../components/editable/EditableText.js";
import "../../../components/editable/EditableSelect.js";
import "uuid";
import "../../../components/editable/EditableAutocomplete.js";
import { useValidationFormatter, useCustomValidationFormatter, RuleType } from "../../../components/input/validation.js";
import "../../../components/input/DatePicker.js";
import "../../../components/input/DateRangePicker.js";
import "../../../components/input/StyledInput.js";
import { FormSelect, FormError, FormTextInputCleanable, FormTextInputDefault } from "../../../components/input/FormInput.js";
import "../../../components/input/StyledFormInputHoc.js";
import "moment-timezone";
import "../../../components/input/DateSinglePicker.localize.js";
import "../../../components/input/hooks.js";
import { dashCharacter } from "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import "@apollo/client";
import "immer";
import "rxjs";
import "../../../api/types.js";
import "@apollo/client/errors";
import "rxjs/operators";
import "graphql";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "@automapper/core";
import "date-fns";
import "../../user-profile/constants.js";
import "react-redux";
import "../../../user-settings/components/UserSettingsProvider.js";
import "react-oidc-context";
import "react-router";
import "oidc-client-ts";
import "../../../auto-mapper/AutoMapperProvider.js";
import "../../../redux-folder/async-actions/actions.js";
import "../../../redux-folder/async-actions/selectors.js";
import "../../../intl/shared-resources/serverResponse.js";
import "typesafe-actions";
import "redux-observable";
import "../../../redux-folder/async-action/action.js";
import "../../../redux-folder/error-handling/action.js";
import "../../../redux-folder/actions.js";
import "../../../redux-folder/async-actions/reducers.js";
import "../../../redux-folder/download/actions.js";
import "../../../redux-folder/download/epics.js";
import "../../../ioc-container/inversifyProvider.js";
import "fast-deep-equal";
import "normalizr";
import "fast-deep-equal/es6";
import "redux";
import "../../../redux-folder/entity/epics.js";
import "../../../redux-folder/entity/EntityProvider.js";
import "reselect";
import "../../../redux-folder/realtime/RealtimeNotification.js";
import "../../user-profile/components/DataGrid.js";
import "../../user-profile/actions.js";
import "../../user-profile/epics.js";
import "../../user-profile/components/Platform.js";
import "../../../components/download/DownloadCsvButton.js";
import "../../../components/download/DownloadTemplate.js";
import "../../../components/filter/FilterGroupNew.js";
import "../../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../../components/filter/date-filter/DateFilter.js";
import "../../../components/filter/TextFilterWithDropdown.js";
import "../../../components/filter/MultiStepFilterDrawer.js";
import "../../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import "../../../components/select/Select.js";
import "../../../components/filter/TextFilter.js";
import "../../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../../components/filter/dateRangeFilter/localized.js";
import "../../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../../components/filter/MultiStepFilterApplyButton.js";
import "../../../components/filter/MultiStepFilterInput.js";
import "../../../components/filter/MultiStepFilterHoc.js";
import "../../../components/select/selectStyle.js";
import "../../../components/select/MultiSelectFooter.js";
import "../../../components/select/MultiSelect.js";
import "../../../components/select/MultiSelectItem.js";
import "../../../components/select/SelectArrowIcon.js";
import "../../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../../components/select/SingleSelect.js";
import "../../../components/select/MultiSelectWithExclude.js";
import "../../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../../components/filter/PhoneFilter.js";
import "../../brand-license/constants.js";
import "../../country/components/CountryFilter.js";
import "../../brand-license/components/BrandProvider.js";
import "../../../components/alerts/NoAccessInfoMessage.js";
import "../../brand-license/components/LicenseSelect.js";
import "../../brand-license/components/BrandSelect.js";
import "../../../components/circle-box/CircleBoxWithText.js";
import "../../../components/tooltip/Tooltip.js";
import "../../../components/tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../../components/tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../../components/tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import "@mui/material/colors";
import "@mui/material/locale";
import "@mui/material/styles";
import "../../../style/hooks.js";
import "../../../components/circle-box/CircleBox.js";
import "../../user-profile/components/Filters.js";
import "../../user-profile/components/P2PStatusCell.js";
import "../../user-profile/components/UserDetailsWDBalance.js";
import "../../user-profile/components/ReferralLinkButton.js";
import { PlayerIdAutocomplete } from "../../user-profile/components/PlayerIdAutocomplete.js";
import { getBtagRegex } from "../constants.js";
import { ReferrerType } from "../service.js";
const localizedReferrerType = defineMessages({
  [ReferrerType.P2P]: {
    id: "referrerType_P2P",
    defaultMessage: "P2P"
  },
  [ReferrerType.Affiliate]: {
    id: "referrerType_Affiliate",
    defaultMessage: "Affiliate"
  }
});
const localized = defineMessages({
  type: {
    id: "ReferrerInfo_Type",
    defaultMessage: "Type"
  },
  typeFieldName: {
    id: "ReferrerInfo_typeFieldName",
    defaultMessage: "Type"
  },
  trackingIdFieldName: {
    id: "ReferrerInfo_trackingIdFieldName",
    defaultMessage: "Tracking ID"
  },
  invalidReferenceMessage: {
    id: "ReferrerInfo_invalidReferenceMessage",
    defaultMessage: "Invalid Reference"
  },
  selfReferrerMessage: {
    id: "ReferrerInfo_selfReferrerMessage",
    defaultMessage: "Not allowed to set the user as the referrer of himself"
  },
  agentLabel: {
    id: "ReferrerInfo_agentLabel",
    defaultMessage: "Agent"
  },
  notFoundErrorMessage: {
    id: "ReferrerInfo_notFoundErrorMessage",
    defaultMessage: "Referrer ID is not found"
  }
});
const useClasses = makeStyles()((theme) => ({
  userReferralReferrerTypeSelect: {
    margin: 0,
    minWidth: "230px"
  },
  userReferralBtagInput: {
    marginBottom: 0,
    "& .MuiOutlinedInput-root": {
      height: "36px"
    }
  },
  userReferralInfoReadMode: {
    display: "flex",
    columnGap: theme.spacing(1.25),
    marginLeft: theme.spacing(2),
    alignItems: "center"
  },
  userReferralInput: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      height: "36px"
    }
  }
}));
const UserReferralInfoFormContentInternal = ({
  control,
  trigger,
  referral,
  userId,
  isAgentReferrer,
  mode,
  referrerInfoMode,
  formErrorState,
  onFormErrorStateChange,
  aal_groups,
  availableTypes = [ReferrerType.Affiliate, ReferrerType.P2P]
}) => {
  const { classes } = useClasses();
  const validationMessageFormatter = useValidationFormatter();
  const customValidationFormatter = useCustomValidationFormatter();
  const { formatMessage } = useIntl();
  const watched = useWatch({
    control
  });
  const typeSelectOptions = Object.values(ReferrerType).filter((type) => availableTypes.includes(type)).map((type) => ({
    value: type,
    label: formatMessage(localizedReferrerType[type])
  }));
  function handleFormErrorStateChange(state) {
    if (onFormErrorStateChange) {
      onFormErrorStateChange(state);
    }
    if (trigger) {
      trigger();
    }
  }
  function getP2PValidationMessage(value) {
    let result = null;
    if (value === userId) {
      result = customValidationFormatter(localized.selfReferrerMessage);
    } else if (formErrorState === "not_found") {
      result = customValidationFormatter(localized.notFoundErrorMessage);
    }
    return result;
  }
  return mode === "Edit" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Controller,
    {
      render: ({ field, fieldState }) => /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(
        FormSelect,
        {
          key: "referrer_type",
          value: field.value,
          onChange: field.onChange,
          options: typeSelectOptions,
          fieldState,
          label: localized.type,
          displayEmpty: true,
          hideError: true,
          className: classes.userReferralReferrerTypeSelect,
          disabled: referrerInfoMode === "remove-only"
        }
      ), fieldState.invalid ? /* @__PURE__ */ React.createElement(FormError, null, fieldState.error?.message) : /* @__PURE__ */ React.createElement(React.Fragment, null)),
      name: "referrer_type",
      control,
      defaultValue: referral?.referrer_type,
      rules: {
        required: validationMessageFormatter(RuleType.Required, localized.typeFieldName)
      }
    }
  ), /* @__PURE__ */ React.createElement(
    Controller,
    {
      render: ({ field, fieldState }) => {
        return watched?.referrer_type === ReferrerType.P2P ? referrerInfoMode === "remove-only" ? /* @__PURE__ */ React.createElement(
          FormTextInputCleanable,
          {
            className: classes.userReferralInput,
            value: field.value,
            onChange: field.onChange,
            clear: () => field.onChange(null),
            placeholder: localized.trackingIdFieldName,
            hasBottomSpacing: false,
            fullWidth: false,
            disabled: true
          }
        ) : /* @__PURE__ */ React.createElement(
          PlayerIdAutocomplete,
          {
            placeholder: localized.trackingIdFieldName,
            optionsFilter: (v) => v !== userId,
            value: field.value,
            onValueChange: field.onChange,
            errorMessage: fieldState.invalid ? fieldState.error?.message : null,
            onFormErrorStateChange: handleFormErrorStateChange
          }
        ) : /* @__PURE__ */ React.createElement(
          FormTextInputDefault,
          {
            className: classes.userReferralBtagInput,
            value: field.value,
            onChange: field.onChange,
            label: localized.trackingIdFieldName,
            placeholder: localized.trackingIdFieldName,
            fieldState,
            hideLabel: true
          }
        );
      },
      name: "referrer_id",
      control,
      defaultValue: referral?.referrer_id,
      rules: {
        pattern: watched?.referrer_type === ReferrerType.Affiliate ? {
          value: getBtagRegex(),
          message: customValidationFormatter(localized.invalidReferenceMessage)
        } : null,
        validate: watched?.referrer_type === ReferrerType.P2P ? getP2PValidationMessage : null
      }
    }
  )) : /* @__PURE__ */ React.createElement(Box, { className: classes.userReferralInfoReadMode }, /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, referral?.referrer_type ?? dashCharacter), referral?.referrer_id ? /* @__PURE__ */ React.createElement(MemoizedDefaultChip, { value: referral?.referrer_id, variant: ChipVariant.Grey, type: ChipType.Status }) : null, isAgentReferrer && referral?.referrer_id ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Chip, { label: formatMessage(localized.agentLabel), size: "small" }), aal_groups?.map((aal) => /* @__PURE__ */ React.createElement(Chip, { label: aal, size: "small" }))) : null);
};
const UserReferralInfoFormContent = withEditButton(UserReferralInfoFormContentInternal);
export {
  UserReferralInfoFormContent
};
//# sourceMappingURL=ReferrerInfoFormContent.js.map
